import { GuiaDTO } from "./guia";
import { DireccionClienteDTO, ContactoCliente, DiaSemana } from "./cliente";
import { StatusGuia } from "./status";
import { DateTime } from "kea-react";

/**
* Un contrarecibo esta relacionado uno a uno con una factura, este es un documento que se utiliza para la cobranza de las guias a credito.
* Note que la fecha de generación del contrarecibo es la fecha de generación de la factura.
* /// Ademas un contrarecibo se considera cancelado si su factura esta cancelada.
*/
export interface Contrarecibo {

    IdRegistro: number;

    /**Conjunto de guias facturadas y en este contrarecibo, la factura se obtiene de esta relación. Esta es la llave primaria del contrarecibo */
    IdFacturaGuias: number;

    /**True si el contrarecibo ya fue impreso */
    Impreso: boolean;

    /**Cliente a quien se le va a cobrar */
    IdCliente: number;
}


export enum TipoEntregaGuia {
    Ocurre,
    Domicilio
}

/**DTO de las guías que se pueden seleccionar para ser facturadas en cobranza */
export interface GuiaCobranzaDto {
    Folio: string;
    TipoEntrega: TipoEntregaGuia;
    FechaCreacion: Date | string;
    FechaEntrega: Date | string;

    IdClienteOrigen: number;
    NombreClienteOrigen: string;
    SucursalOrigen: string;


    IdClienteDestino: number;
    NombreClienteDestino: string;

    SucursalDestino: string;
    DireccionDestino: string;

    ImporteTotal: number;
}

/**DTO de los paquetes pp que se pueden seleccionar para ser facturados en cobranza */
export interface PaquetePPCobranzaDto {
    IdPaquetePP: number;
    Folio: string;
    FechaCreacion: Date | string;
    IdClienteOrigen: number | null;
    NombreClienteOrigen: string;
    IdClienteDestino: number | null;
    NombreClienteDestino: string;
    ImporteTotal: number;
    IdSucursalCobranza: number | null;
    IdClientePaga: number;
}

/**
  * Listado de guias agrupadas por clientes, son la sugerencia de los contrarecibos de los cuales el usuario deberá de seleccionar las guias de las que desea que sean
  * creados los contrarecibos
  */
export interface ContrareciboSugeridoModel {
    /**Id del cliente a quien se le va a factura-r */
    IdCliente: number;

    /**Nombre del cliente */
    NombreCliente: string;

    /**Id de la sucursal de cobranza del cliente */
    IdSucursalCobranza: number | null;

    /**Nombre de la sucursal de cobranza */
    NombreSucursalCobranza: string;

    /**Listado de las guias que pueden entrar en el contrarecibo */
    Guias: GuiaCobranzaDto[];

    /**Listado de los paquetes pp que pueden entrar en el contrarecibo */
    Paquetes: PaquetePPCobranzaDto[];
}


/**Filtro de guías para la parte de generación de contrarecibos */
export interface FiltroGuiasContrarecibos {
    IdSucursalCobranza?: number | null;
    IdClientePaga?: number | null;
    FechaCreacionInicio?: DateTime| null;
    FechaCreacionFinal?: DateTime | null;
    EsGuiaLogistica: boolean;
}

export interface FiltroPaquetesPPContrarecibos {
    IdSucursalCobranza?: number | null;
    IdClientePaga?: number | null;
}

/**Un cliente que tiene facturas pendientes de pagar */
export interface ClientePendienteDto {
    IdCliente: number;
    NombreCliente: string;

    /**Total del saldo de las facturas */
    SaldoFacturas: number;

    /**Cant. de facturas de crédito que aún no están pagadas, esten o no esten vencidas */
    FacturasPendientes: number;

    /**Cant. de facturas de crédito que aún no están pagadas y que estan vencidas */
    FacturasVencidas: number;
}


// WEBPACK FOOTER //
// ./app/models/cobranza.ts